// icon:317-arrow-right2 | Icomoon https://icomoon.io/ | Keyamoon
import * as React from "react";

function Icon317ArrowRight2(props) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="currentColor"
      height="0.7em"
      width="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.707 13.707l5-5a.999.999 0 000-1.414l-5-5a.999.999 0 10-1.414 1.414L11.586 7H2a1 1 0 000 2h9.586l-3.293 3.293a.997.997 0 000 1.414.999.999 0 001.414 0z"
      />
    </svg>
  );
}

export default Icon317ArrowRight2;
